<script>
import {Config as PixelStreamingConfig, PixelStreaming} from '@homepage/helpers/pixel-streaming';

export default {
  name: 'AdvancedPixelStreamer',
  props: {
    serverUrl: {
      type: String,
      required: true
    }
  },
  mounted() {
    const config = new PixelStreamingConfig({
      initialSettings: {
        AFKTimeout: 0,
        MaxReconnectAttempts: -1,
        AutoPlayVideo: true,
        AutoConnect: false,
        ss: this.serverUrl,
        StartVideoMuted: false,
        HoveringMouse: false,
        WaitForStreamer: true,
        useUrlParams: false,
        PreferredCodec: 'H.264',
      }
    })

    this.connectPixelStreamingSocket(config);
  },
  data() {
    return {
      streamerConnected: false,
      listStreamerInterval: null,
      streamingRef: null,
      showWaitingMessage: true,
      requestStreamerListTimeout: null,
    };
  },
  destroyed() {
    if (this.streamingRef) {
      this.streamingRef.disconnect();
    }
    clearTimeout(this.requestStreamerListTimeout);
  },
  methods: {
    connectPixelStreamingSocket(config) {
      console.log("Connecting to pixel streaming socket");
      const streaming = new PixelStreaming(config, {
        videoElementParent: this.$refs.player
      });
      streaming.addEventListener('streamerListMessage', (payload) => {
        const streamerIdNotSetYet = payload.data.messageStreamerList.ids.includes("__LEGACY__")
        if (payload.data.messageStreamerList.ids.length === 0 || streamerIdNotSetYet) {
          streaming.disconnect();
          if (streamerIdNotSetYet) {
            setTimeout(() => {
              this.connectPixelStreamingSocket(config);
            }, 3000)
          }
        } else {
          this.streamingRef = streaming;
          streaming.addEventListener('webRtcDisconnected', () => {
            this.goToBoard();
          });
        }
      })
      streaming.addEventListener('webRtcConnected', () => {
        this.showWaitingMessage = false;
      })
			streaming.connect();
    },
    goToBoard() {
			this.$emit('go-to-board');
    },
  }
};
</script>
<template>
  <div id='stream' class='w-100 h-100 text-center'>
    <div ref='player' id='player'/>
    <slot :show-waiting-message="showWaitingMessage">
    </slot>
  </div>
</template>

